// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + "assets_3.22.0/js/[name].bundle" + "-" + "1b7c133874cd5ea5d210" + "-bundle.js";
};